module.exports = __webpack_public_path__ + "img/iconNo6.da4e3523.png";